import { combineReducers } from "redux";

import citasServicioReducer from "./citasServicioReducer";
import configuradorReducer from "./configuradorReducer";
import audiNuevoReducer from "./audiNuevoReducer";
import compramosTuAutoReducer from "./compramosTuAutoReducer";
import audiCampaignReducer from "./audiCampaignReducer";
import pruebaDeManejo from "./pruebaDeManejo";
import contacto from "./contactoReducer";
import vtpNuevos from "./vtpNuevosReducer";
import vtpUsados from "./vtpUsadosReducer";
import accesoriosReducer from "./accesoriosReducer";

export default combineReducers({
  citasServicio: citasServicioReducer,
  configurador: configuradorReducer,
  audiNuevo: audiNuevoReducer,
  compramosTuAuto: compramosTuAutoReducer,
  campaign: audiCampaignReducer,
  pruebaDeManejo: pruebaDeManejo,
  contacto: contacto,
  vtpNuevos: vtpNuevos,
  vtpUsados: vtpUsados,
  accesorios: accesoriosReducer
});
